import { render, staticRenderFns } from "./ProspectCRProject.vue?vue&type=template&id=b3c88ccc&scoped=true&"
import script from "./ProspectCRProject.vue?vue&type=script&lang=js&"
export * from "./ProspectCRProject.vue?vue&type=script&lang=js&"
import style0 from "./ProspectCRProject.vue?vue&type=style&index=0&id=b3c88ccc&prod&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c88ccc",
  null
  
)

export default component.exports